import { getUserFullName } from '@/lib/utils/user/getUserFullName'
import useGlobalStore from '@/store/useGlobalStore'
import React from 'react'
import { Copy } from '@/components/_referrals/Copy'
import ProfilePicture from '../../ProfilePicture'

const AccountTitle = ({
  isAccountPopover = false,
}: {
  isAccountPopover?: boolean
}) => {
  const { user } = useGlobalStore()

  return (
    <div className="my-5 flex items-center space-x-3 text-primary">
      <div>
        <ProfilePicture size={50} />
      </div>
      <div>
        <h4 className="text-lg font-bold" data-test="user-name">
          {getUserFullName(user.customer?.humanName)}
        </h4>
        <Copy isAccountPopover={isAccountPopover} />
      </div>
    </div>
  )
}

export default AccountTitle
